import { render, staticRenderFns } from "./NhBankPay.vue?vue&type=template&id=88455a9e&scoped=true"
import script from "./NhBankPay.vue?vue&type=script&lang=js"
export * from "./NhBankPay.vue?vue&type=script&lang=js"
import style0 from "./NhBankPay.vue?vue&type=style&index=0&id=88455a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_bg3kgbxtkzfehr6b2f7ajf354m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88455a9e",
  null
  
)

export default component.exports